"use strict";

exports.__esModule = true;
exports.SandvikV2Wrapper = SandvikV2Wrapper;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _base = _interopRequireDefault(require("../base"));
var _hangingLogo = _interopRequireDefault(require("../../../assets/sandvik-v2/hanging-logo.png"));
var _global = require("./global");
var _TooltipGlobals = require("../TooltipGlobals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HangingLogo = _styledComponents["default"].img.withConfig({
  displayName: "SandvikV2Wrapper__HangingLogo",
  componentId: "sc-ar6yd3-0"
})(["z-index:20;position:absolute;right:20px;top:20px;height:40px;width:240px;"]);
var SandvikV2ThemeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SandvikV2Wrapper__SandvikV2ThemeWrapper",
  componentId: "sc-ar6yd3-1"
})(["flex:1;.", " & .", ",.", ".", "{box-shadow:none;border-bottom:solid 1px #aaaaaa;}.settings-menu-container{right:200px;}div.rt-noData{color:", ";background:", ";}"], _core.Classes.DARK, _core.Classes.NAVBAR, _core.Classes.NAVBAR, _core.Classes.DARK, _base["default"].DataTableMessageColor, _base["default"].DataTableMessageBackground);
function SandvikV2Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(SandvikV2ThemeWrapper, null, /*#__PURE__*/_react["default"].createElement(_global.SandvikV2Global, null), /*#__PURE__*/_react["default"].createElement(_TooltipGlobals.TooltipGlobals, null), /*#__PURE__*/_react["default"].createElement(HangingLogo, {
    src: _hangingLogo["default"]
  }), children);
}